import React, { Component } from 'react'
import './element-header.css';

export default class ElementHeader extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  hasAiConnector() {
    var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
    var aiConnector = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1))
    return aiConnector !== undefined;
    // var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
  }

  render() {
    const {
      canEditComposition,
      canEditElement,
      enabledWorkflows,
      isUserCreatorColaborator,
      isUserCreatorViewer
    } = this.props;

    var up = <button className="rdp-composer-element-header-up-btn" onClick={() => this.props.onUp()}></button>;
    var down = <button className="rdp-composer-element-header-down-btn" onClick={() => this.props.onDown()}></button>;

    if (this.props.index === 0) {
      up = "";
      down = <button className="rdp-composer-element-header-down-btn alone" onClick={() => this.props.onDown()}></button>;
    };
    if (((this.props.index === this.props.length - 1) && this.props.length > 1) || this.props.length === 1) {
      down = "";
    };

    return (
      <div className="rdp-composer-element-header">
        <div className="rdp-composer-element-header-left">
          {canEditComposition && !isUserCreatorViewer && !isUserCreatorColaborator && <>{up}</>}
          {canEditComposition && !isUserCreatorViewer && !isUserCreatorColaborator &&<>{down}</>}
        </div>
        <div className="rdp-composer-element-header-right">
          {canEditElement && enabledWorkflows && canEditComposition &&
            <button className="rdp-composer-element-header-activities-btn" onClick={() => this.props.onOpenActivities()}>Instruções</button>
          }
          {this.hasAiConnector() && this.props.ia && canEditComposition && !isUserCreatorViewer &&
            // OPEN AI INTELIGÊNCIA ARTIFICIAL IA AI
            <button className="rdp-composer-element-header-ia-btn" onClick={() => this.props.onIa()}></button>
          }
          {/* {this.props.renderObjectMessages && canEditComposition &&
            <button className="rdp-composer-element-header-message-btn" onClick={() => this.props.onOpenMessages()}></button>
          } */}
          {canEditComposition && !isUserCreatorViewer && !isUserCreatorColaborator &&
            <button className="rdp-composer-element-header-copy-btn" onClick={() => this.props.onCopy()}></button>
          }
          {canEditElement && canEditComposition && !isUserCreatorViewer &&
            <button className="rdp-composer-element-header-edit-btn" onClick={() => this.props.onEdit()}></button>
          }
          {canEditComposition && !isUserCreatorViewer && !isUserCreatorColaborator &&
            <button className="rdp-composer-element-header-remove-btn" onClick={() => this.props.onRemove()}></button>
          }
        </div>
      </div>
    );
  }
}
